module.exports = __webpack_public_path__ + "static/media/happy_clock.a8e93084.svg";